import {Entity} from "../helpers/Entity"

export type SearchResult<dataT> = {
    data: dataT[]
    metadata: MetadataDto
}

export type dataDto = {
    id: string
    name: string
}

export interface SearchResultDto {
    data: dataDto[],
    metadata: MetadataDto
}

interface MetadataDto {
    totalItemsCount: number,
    pageSize: number,
    activePage: number,
}

export default class SearchResults implements Entity{
    data: dataDto[]
    metadata: MetadataDto

    constructor(dto: SearchResultDto) {
        this.data = dto.data
        this.metadata = dto.metadata
    }

    isLoaded(): boolean {
        return !!this.data
    }

    getId(): string {
        return ""
    }

    hasResults(){
        return this.data.length > 0
    }

    getData(){
        return this.data
    }

}


// WEBPACK FOOTER //
// ./src/state/search/Search.ts